export enum UserStatus {
    IDLE,
    ONLINE,
    AUTHENTICATING,
    UNAUTHORIZED,
    OFFLINE
}